module.exports = "/images/avatar-s-18.jpg?3622d7f0e8504fcf79496d66c5f1e888";